<div class="d-flex justify-content-end gap-2 mb-3">
  <button class="btn btn-sm btn-success d-flex align-items-center gap-1" (click)="openDeposit()">
    <i class="material-icons" style="font-size: 16px;">add</i> Agregar crédito
  </button>
  @if(creditBalance > 0) {
    <button class="btn btn-sm btn-outline-warning" (click)="openRefund()">
      Reembolsar
    </button>
  }
</div>

<p-table
  [value]="creditTransactions"
  [loading]="loading"
  [rowHover]="true"
  [paginator]="true"
  [rows]="10"
  [rowsPerPageOptions]="[10, 25, 50]"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros">
  <ng-template pTemplate="header">
    <tr>
      <th>Fecha</th>
      <th>Tipo</th>
      <th>Monto</th>
      <th>Notas</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-tx>
    <tr class="p-selectable-row">
      <td>{{ tx.createdAt | dateToMoment: 'DD MMM YYYY' }}</td>
      <td>
        @if(tx.type === 'deposit') {
          <span class="badge rounded-pill text-bg-success">Depósito</span>
        } @else if(tx.type === 'applied') {
          <span class="badge rounded-pill text-bg-primary">Aplicado</span>
        } @else {
          <span class="badge rounded-pill text-bg-warning">Reembolso</span>
        }
      </td>
      <td>{{ tx.amount | currency }}</td>
      <td class="text-secondary">{{ tx.notes }}</td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="4" class="text-center text-muted py-4">
        <i class="material-icons d-block mb-1" style="font-size: 1.5rem; opacity: 0.4;">receipt_long</i>
        <small>Sin transacciones de crédito</small>
      </td>
    </tr>
  </ng-template>
</p-table>
